module.exports = __webpack_public_path__ + "7fd7f16f731064bcbc043c6565451773.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-kawauso-sirabetemimasu.png
// module id = 2072
// module chunks = 4